var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuesaxOutlineLampCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-556 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.922,6.706a.686.686,0,0,1-.37-.1.754.754,0,0,1-.28-1.02l.85-1.48h-.84a1.267,1.267,0,0,1-1.13-.59A1.256,1.256,0,0,1,.2,2.236L1.272.376a.748.748,0,1,1,1.3.74l-.85,1.49h.84a1.267,1.267,0,0,1,1.13.59,1.256,1.256,0,0,1-.05,1.28l-1.07,1.86A.746.746,0,0,1,1.922,6.706Z",
    transform: "translate(566.078 195.144)",
    fill: "#0baa3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,18.483H5.89a1.863,1.863,0,0,1-1.37-.43,1.448,1.448,0,0,1-.34-1.14v-.89A9.276,9.276,0,0,1,0,8.643,8.655,8.655,0,0,1,10.6.213a8.54,8.54,0,0,1,5.78,4.47,9,9,0,0,1-3.26,11.35v.75a1.6,1.6,0,0,1-.39,1.24A1.834,1.834,0,0,1,11.4,18.483Zm-5.73-1.51c.05,0,.12.01.21.01H11.4a.91.91,0,0,0,.21-.02V15.6a.751.751,0,0,1,.36-.64,7.515,7.515,0,0,0,3.05-9.63,7.01,7.01,0,0,0-4.76-3.67,7.214,7.214,0,0,0-6.11,1.4,7.127,7.127,0,0,0-2.67,5.58,7.831,7.831,0,0,0,3.82,6.33.742.742,0,0,1,.36.64v1.35C5.67,16.963,5.67,16.963,5.67,16.973Z",
    transform: "translate(559.37 189.267)",
    fill: "#0baa3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.761,2a.761.761,0,0,1-.21-.03,11.907,11.907,0,0,0-6.59,0,.76.76,0,0,1-.93-.52.752.752,0,0,1,.52-.93,13.522,13.522,0,0,1,7.41,0,.755.755,0,0,1,.52.93A.736.736,0,0,1,7.761,2Z",
    transform: "translate(563.739 208.753)",
    fill: "#0baa3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    transform: "translate(556 188)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLampCharge);
export default __webpack_public_path__ + "static/media/vuesax-outline-lamp-charge.ac1059c251c7f45e6c8b734ec241b4b9.svg";
export { ForwardRef as ReactComponent };